import React, { useContext } from 'react';
import { ReorderRuleExportConfigurationContext } from '../../../../../context/ReorderRuleExportConfigurationContext';
import { ExportConfigurationsPane } from '../../../../components/ExportItems';

export default function ReorderRuleReportPane() {
  const { reorderRuleExportConfigurations, reorderRuleExportConfigurationsLoading } = useContext(
    ReorderRuleExportConfigurationContext,
  );

  return (
    <ExportConfigurationsPane
      configurations={[...reorderRuleExportConfigurations.values()]}
      loading={reorderRuleExportConfigurationsLoading}
    />
  );
}
